import type React from "react";
import { createContext, useCallback, useContext, useState } from "react";

import { ToastQueue, ToastRegion, type ToastContent } from "@stacklet/ui";

export type AlertStatus = ToastContent;

interface Context {
  alertDispatch: React.Dispatch<AlertStatus>;
}

const AlertContext = createContext<Context>({
  alertDispatch: () => {
    // do nothing
  },
});

export function AlertProvider({ children }: React.PropsWithChildren) {
  const [queue] = useState(
    () => new ToastQueue<ToastContent>({ maxVisibleToasts: 3 }),
  );

  const alertDispatch = useCallback(
    (action: AlertStatus) => {
      queue.add(action, {
        timeout: action.duration ?? 5000,
      });
    },
    [queue],
  );

  return (
    <AlertContext.Provider value={{ alertDispatch }}>
      <ToastRegion queue={queue} />
      {children}
    </AlertContext.Provider>
  );
}

export function useAlertContext(): Context {
  return useContext(AlertContext);
}
